import React, { PropsWithChildren, useCallback, useContext, useRef } from 'react';

import { CustomBottomSheetModalProvider } from '@/feature/alerts/components/CustomBottomSheetModalProvider';

import { OddsChangeModal, OddsChangeModalRef } from './OddsChangeModal';

type OddsChangeModalContextType = {
    showOddsChangeModal: () => void;
    dismissOddsChangeModal: () => void;
};

const OddsChangeModalContext = React.createContext<OddsChangeModalContextType | null>(null);

export const OddsChangeModalProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const modalRef = useRef<OddsChangeModalRef>(null);

    const showOddsChangeModal = useCallback(() => {
        modalRef.current?.show();
    }, []);

    const dismissOddsChangeModal = useCallback(() => {
        modalRef.current?.dismiss();
    }, []);

    return (
        <CustomBottomSheetModalProvider>
            <OddsChangeModalContext.Provider value={{ showOddsChangeModal, dismissOddsChangeModal }}>
                {children}
                <OddsChangeModal ref={modalRef} />
            </OddsChangeModalContext.Provider>
        </CustomBottomSheetModalProvider>
    );
};

export const useOddsChangeModal = () => {
    const context = useContext(OddsChangeModalContext);
    if (!context) {
        throw new Error('useOddsChangeModal must be used within an OddsChangeModalProvider');
    }
    return context;
};
